import { render, staticRenderFns } from "./vlis.vue?vue&type=template&id=4a459509&scoped=true&"
import script from "./vlis.vue?vue&type=script&lang=js&"
export * from "./vlis.vue?vue&type=script&lang=js&"
import style0 from "./vlis.vue?vue&type=style&index=0&id=4a459509&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a459509",
  null
  
)

export default component.exports